export default __webpack_public_path__ + "static/header-subheader-anatomy-dark-edc99e8b2d63925b8d0321f14dbbcf95c75fe4aa6ba466ad828728f433ec23f8.png";